export default __webpack_public_path__ + "static/media/Cake_white.2576dc07.svg";